import { useMutation } from '@tanstack/react-query';

export interface UpdateMealPlanInstructions {
  id?: string;
  healthieClientId?: number;
  healthieProviderId?: number;
  dietaryRestrictionsAndAllergies: string;
  calorieAndMacroRequirements: string;
  householdConsiderations: string;
  otherGuidance: string;
  foodPreferences: string;
}

interface UpdateMealPlanInstructionsResponse {
  status: string;
  id?: string;
}

const updateMealPlanInstructions = async (
  payload: UpdateMealPlanInstructions,
): Promise<UpdateMealPlanInstructionsResponse> => {
  const res = await fetch('/api/meal-plan/update-meal-plan-instructions', {
    method: 'PUT',
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    throw new Error(`Failed to update meal plan instructions: ${res.status}`);
  }

  return res.json();
};

export const useUpdateMealPlanInstructions = () =>
  useMutation({
    mutationFn: (payload: UpdateMealPlanInstructions) =>
      updateMealPlanInstructions(payload),
  });
